import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'

import Option from './Option'
import { QuestionWrapper, QuestionText, QuestionTextSpan, OptionsWrapper, QuestionBackLink, QuestionPlusWrapper, QuestionMinusWrapper, QuestionMinutes } from '../StyledComponents/IntroQuestions/Question'

class TimeQuestion extends Component {
    constructor(props) {
        super(props)

        this.state = { hours: 18, minutes: 0 }
        this.decrementMinutes = this.decrementMinutes.bind(this)
        this.incrementMinutes = this.incrementMinutes.bind(this)
        this.decrementHours = this.decrementHours.bind(this)
        this.incrementHours = this.incrementHours.bind(this)
    }

    decrementMinutes() {
        const newValue = (this.state.minutes + (60 - 15)) % 60
        this.setState({ minutes: newValue })
    }

    incrementMinutes() {
        const newValue = (this.state.minutes + 15) % 60
        this.setState({ minutes: newValue })
    }

    decrementHours() {
        const newValue = (this.state.hours + (24 - 1)) % 24
        this.setState({ hours: newValue })
    }

    incrementHours() {
        const newValue = (this.state.hours + 1) % 24
        this.setState({ hours: newValue })
    }

    render() {
        const {
            text, options, onAnswerClicked, onBackClicked, nextQuestion,
        } = this.props

        const label = options && options.length > 0 ? options[0].label : 'Bestätigen'

        const option = {
            label,
            value: `${this.state.hours}:${(`0${this.state.minutes}`).slice(-2)}`,
            nextQuestion,
        }

        const backLink = (
            <QuestionBackLink onClick={onBackClicked} >
                <FontAwesome
                    name="arrow-left"
                    size="lg"
                />
            </QuestionBackLink>
        )

        return (
            <QuestionWrapper>
                {backLink}
                <QuestionText marginBottom="20" minHeight="70">
                    <QuestionTextSpan>{text}</QuestionTextSpan>
                </QuestionText>
                <div className="row">
                    <div className="col">
                        <QuestionPlusWrapper align="right" onClick={this.incrementHours}>
                            <FontAwesome
                                name="arrow-up"
                                size="3x"
                            />
                        </QuestionPlusWrapper>
                        <QuestionMinutes align="right">
                            {`${this.state.hours}`}
                        </QuestionMinutes>
                        <QuestionMinusWrapper align="right" onClick={this.decrementHours}>
                            <FontAwesome
                                name="arrow-down"
                                size="3x"
                            />
                        </QuestionMinusWrapper>
                    </div>
                    <QuestionMinutes className="col-2" lineHeight="216">
                        :
                    </QuestionMinutes>
                    <div className="col">
                        <QuestionPlusWrapper align="left" onClick={this.incrementMinutes}>
                            <FontAwesome
                                name="arrow-up"
                                size="3x"
                            />
                        </QuestionPlusWrapper>
                        <QuestionMinutes align="left">
                            {`${(`0${this.state.minutes}`).slice(-2)}`}
                        </QuestionMinutes>
                        <QuestionMinusWrapper align="left" onClick={this.decrementMinutes}>
                            <FontAwesome
                                name="arrow-down"
                                size="3x"
                            />
                        </QuestionMinusWrapper>
                    </div>
                </div>
                <OptionsWrapper marginTop="50">
                    <Option
                        data={option}
                        fullWidth={false}
                        onOptionClicked={onAnswerClicked}
                    />
                </OptionsWrapper>
            </QuestionWrapper>
        )
    }
}

export default TimeQuestion



// WEBPACK FOOTER //
// ./src/components/IntroQuestions/TimeQuestion.js